import { initTiktokPixel, trackEventSingleTiktok } from '../tiktokPixel';
import { checkTrackingConversion } from './helpers/util';
import tiktokPixelEvent from '../../data/tiktokPixelEvent';

function createTiktokEventObject(eventName, data) {
  const expectedParams = tiktokPixelEvent[eventName] || [];
  const eventData = {
    currency: data.currency || "IDR",
    content_type: data.content_type || "product",
  };

  for (const paramName of expectedParams) {
    if (paramName === 'content_id') {
      const contentIds = data.content_ids;
      if (Array.isArray(contentIds) && contentIds.length > 0) {
        eventData.content_id = String(contentIds[0]);
      } else if (contentIds && !Array.isArray(contentIds)) {
        eventData.content_id = String(contentIds);
      }
    } else if (data[paramName] !== undefined && data[paramName] !== null) {
      eventData[paramName] = data[paramName];
    }
  }
  return eventData;
}

export async function handleTikTokPixelTracking(tiktokTracking, data, globalConversionSetting) {
  for (const pixel of tiktokTracking) {
    const pixelId = pixel.pixelId || '';
    const shouldProcess = await checkTrackingConversion(
      pixel,
      `pixelsTiktok_${pixelId}`,
      globalConversionSetting,
      data.event_key
    );
    if (!shouldProcess) continue;

    initTiktokPixel(pixelId);
    if (pixel.pixelEvents && pixel.pixelEvents.length) {
      for (const event of pixel.pixelEvents) {
        if (event.name && pixel.enablePixelEvent) {
          const object = createTiktokEventObject(event.name, data);
          trackEventSingleTiktok(pixelId, event.name, object);
        }
      }
    }
  }
}
